import React from "react"
import types from "prop-types"
import clsx from "clsx"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const ChevronUp = ({
  className = "",
  width = undefined,
  height = undefined,
  onClick = () => {},
}) => (
  <SvgSpriteIcon
    className={clsx(className, "text-dark")}
    iconName="chevron-up"
    width={width}
    height={height}
    onClick={onClick}
    ariaHidden
  />
)

ChevronUp.propTypes = {
  className: types.string,
  width: types.number,
  height: types.number,
  onClick: types.func,
}

export default ChevronUp
